export enum collectionsEnum {
    documentations = "_Documentations",
    instructions = "_Instructions",
}
